module.exports = __webpack_public_path__ + "static/media/wealthfront-logo.1bf8db7e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/companies/wealthfront-logo.png
 ** module id = 429
 ** module chunks = 0
 **/